<template>
  <div class="d-flex">
    <button :disabled="!backwardActive"
      class="px-4 py-2 rounded-pill mr-2 w-50"
      :class="[
        backwardActive === true ? 'bg-transparent border border-secondary text-secondary' : 'bg-transparent border',
        backwardVisible !== true ? 'invisible' : ''
      ]"
      @click="$emit('backward-click', {})"
    >{{ $t('step-back') }}</button>

    <button :disabled="!forwardActive"
      class="px-4 py-2 rounded-pill w-50"
      id="forward-button"
      :class="[
        forwardActive === true ? 'bg-saka-orange border border-saka-orange text-white' : 'bg-transparent border',
        forwardVisible !== true ? 'invisible' : ''
      ]"
      @click="$emit('forward-click', {})"
    >{{ $t('step-forward') }}</button>
  </div>
</template>

<script>
export default {
  name: 'ConfigurationNavigation',
  props: {
    backwardActive: {
      type: Boolean,
      default: false
    },
    backwardVisible: {
      type: Boolean,
      default: true
    },
    forwardActive: {
      type: Boolean,
      default: false
    },
    forwardVisible: {
      type: Boolean,
      default: true
    }
  }
}
</script>
